export const GET_SETTLEMENTS_REQUEST = "GET_SETTLEMENTS_REQUEST";
export const GET_SETTLEMENTS_SUCCESS = "GET_SETTLEMENTS_SUCCESS";
export const GET_SETTLEMENTS_FAIL = "GET_SETTLEMENTS_FAIL";

export const GET_DELIVERY_SETTLEMENTS_REQUEST =
  "GET_DELIVERY_SETTLEMENTS_REQUEST";
export const GET_DELIVERY_SETTLEMENTS_SUCCESS =
  "GET_DELIVERY_SETTLEMENTS_SUCCESS";
export const GET_DELIVERY_SETTLEMENTS_FAIL = "GET_DELIVERY_SETTLEMENTS_FAIL";
